@if (labels == null || trainings == null) {
  <app-admin-spinner></app-admin-spinner>
}
<div>
  <div class="row" style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important"><div class="col-11"></div><div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;"><mat-icon style="float:right; cursor: pointer;" (click) = "onNoClick()">cancel</mat-icon></div></div>
  <h2 mat-dialog-title>{{labels.lblAddTrainingToUser}} "{{data.firstName}}"</h2>
  <div mat-dialog-content>
    @if (trainings?.length == 0) {
      <div>
        <h3 style="font-family: 'Prompt', sans-serif !important;">{{labels.lblNoTraining}}</h3>
      </div>
    }
    <form (ngSubmit)="onSubmit()" #userTrainingsForm="ngForm">
      <input type="hidden" name="id" [ngModel]="data._id">
      <div class="row" style="width: 100%;">


      </div>
      <div class="col-sm-12" style="width: 100%; padding-left:0;">
        <h4 style="font-family: 'Prompt', sans-serif;">{{labels.lblTrainings}}:</h4>

        @for (training of trainings; track training) {
          <mat-checkbox
            ngModel
            name="user-training"
            [value]="training"
            [checked]="true"
            class="example-margin checkbox"
            (change)="getTrainingId($event,training)"
            >
            {{training.name}}
          </mat-checkbox >
        }
        <div style="margin: auto;">
          <!-- <button type="button" *ngIf="trainings.length > 0" style="margin: auto" class="noBtn" mat-button (click)="onNoClick()">{{labels.lblNo}}</button> -->
          @if (trainings?.length == 0) {
            <button type="button" class="noBtn" style="float:right; padding-right: 10px; padding-left: 10px; margin-right: 0px !important" mat-button (click)="onNoClick()">{{labels.lblOk}}</button>
          }
          @if (trainings.length > 0) {
            <button type="button"  class="btn" style="float:right; padding-right: 10px; padding-left: 10px; margin-right: 0px !important" mat-button (click)="onSubmit()">{{labels.lblAdd}}</button>
          }
          <!-- <button class="btn" *ngIf="trainings.length > 0" style="float:right; padding-right: 10px; padding-left: 10px; margin-right: 0px !important" cdkFocusInitial type="submit">{{labels.lblAdd}}</button> -->
        </div>
      </div>


    </form>
  </div>
